import React from 'react';

const percent = value => value == null ? '—' : `${value.toFixed(2)}%`;
const number = value => value.toLocaleString();

export const DistinctDigitRepeats = ({ source, distribution }) => {
  const main = source === 'main_balls';
  const id = `digit-distinct-${source}`;
  const title = main ? 'How many main-ball digits repeat in the next draw?' : 'Combined Lucky Star digits → next main balls';
  const label = count => main ? `${count} ${count === 1 ? 'digit' : 'digits'}`
    : count === 0 ? 'Neither (0 digits)' : count === 1 ? 'One digit' : 'Both (2 distinct digits)';
  return <section className="space-y-3 border-t border-gray-200 pt-6" data-testid={`${id}-section`}>
    <div className="flex flex-wrap items-center justify-between gap-2">
      <h2 className="text-base font-bold text-gray-900" data-testid={`${id}-heading`}>{title}</h2>
      {distribution && <span className="text-xs text-gray-600" data-testid={`${id}-eligible-pairs`}>{number(distribution.eligible_pairs)} eligible draw pairs</span>}
    </div>
    <p className="text-xs text-gray-500" data-testid={`${id}-definition`}>
      {main ? 'Distinct last digits shared by consecutive main-ball draws, at any position.' : 'Previous LS1 and LS2 last digits found anywhere in the next Ball1–Ball5.'} A digit appearing more than once still counts once.
    </p>
    {!distribution ? <p className="text-sm text-amber-800" role="status" data-testid={`${id}-unavailable`}>Repeat-count summary unavailable.</p> : <>
      <table className="digit-summary-matrix digit-repeat-distribution" data-testid={`${id}-table`}>
        <thead><tr>
          <th scope="col" data-testid={`${id}-repeat-heading`}>Digits repeated</th>
          <th scope="col" data-testid={`${id}-count-heading`}>Draw pairs</th>
          <th scope="col" data-testid={`${id}-rate-heading`}>Percentage</th>
        </tr></thead>
        <tbody>{[...distribution.categories].sort((a, b) => main ? b.repeated_digits - a.repeated_digits : a.repeated_digits - b.repeated_digits).map(row => <tr key={row.repeated_digits} data-testid={`${id}-row-${row.repeated_digits}`}>
          <th scope="row" data-testid={`${id}-${row.repeated_digits}-label`}>{label(row.repeated_digits)}</th>
          <td data-testid={`${id}-${row.repeated_digits}-counts`}>{number(row.hits)} / {number(row.opportunities)}</td>
          <td className="font-semibold text-gray-900" data-testid={`${id}-${row.repeated_digits}-percentage`}>{percent(row.pct)}</td>
        </tr>)}</tbody>
        <tfoot><tr data-testid={`${id}-total-row`}>
          <th scope="row" data-testid={`${id}-total-label`}>Total</th>
          <td data-testid={`${id}-total-counts`}>{number(distribution.eligible_pairs)} / {number(distribution.eligible_pairs)}</td>
          <td data-testid={`${id}-total-percentage`}>{distribution.eligible_pairs ? '100.00%' : '—'}</td>
        </tr></tfoot>
      </table>
      <p className="text-sm text-gray-700" data-testid={`${id}-any-repeat`}>At least one repeated digit: <strong>{number(distribution.any_repeat.hits)} / {number(distribution.any_repeat.opportunities)} pairs · {percent(distribution.any_repeat.pct)}</strong></p>
      {!distribution.eligible_pairs && <p className="text-xs text-gray-500" data-testid={`${id}-empty`}>No eligible consecutive draw pairs available.</p>}
    </>}
  </section>;
};
